import { Subscription } from "rxjs";
import Utils from "../../shared/utils";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl } from "@angular/forms";
import { WarningdialogComponent } from "../../modalDialogs";
import { CoreCOMService } from "../../services/com.service";
import { CoreLogService } from "../../services/log.service";
import { WebShopService } from "../../services/webShop.service";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { UserHelperService } from "../../services/userHelper.service";
import { CoreLanguageService } from "../../services/language.service";
import { RouterHelperService } from "../../services/routerHelper.service";
import { GeocodingService, Address } from "../../services/geocoding.service";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { GeocodeResponse, Coordinates } from "../../shared/models/geocoding.model";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { FurtherAddressViewModel, WebshopOrderDataViewModel } from "../../shared/models/webshop.model";
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { LocalKeys, StorageHive } from "../../services/valueStorage.service";
import { LocationWebshopViewModel } from "../../shared/models";
import { LocationService } from "../location/location.service";
import { OrderDataInputMaxLength, WebShopMode, DeliveryAddressQueryMaxLength, AnounceModalResult, AddressModalResult } from "../../shared/contentTypes";
import { MatBottomSheetRef, MatRadioButton } from "@angular/material";
import { ValidatorsConfig } from "../../shared/validator/validator.function";
import { DELIVERY_ADDRESS_FIELD_ERROR_MESSAGES } from "../../shared/validator/validatorErrorMessages";
import { AddressVerificationService } from "../../services/addressVerification.service";
import { AddressVerifyResponse, SuggestedAddress } from "../../shared/models/addressVerify.model";
import { AddressVerificationDialogComponent } from "../../modalDialogs/addressVerificationDialog/addressVerificationDialog.component";
import { OrderAddressQueryService } from "./orderAddressQuery.service";
import { IUserAddress } from "../../shared/models/userAddress.model";
import { FieldName } from "../../shared/validator/validatorMessage.interface";
import { DeviceLocationService } from "../../services/deviceLocation.service";

@Component({
  selector: "orderAddressQuery",
  templateUrl: "./orderAddressQuery.component.html",
  styleUrls: ["./orderAddressQuery.component.scss"],
  providers: [OrderAddressQueryService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderAddressQueryComponent implements OnInit, OnDestroy {
  private webshopOrderDataSubscription: Subscription;
  private zipCodeValidSubscriber: Subscription;
  private zipCodeValueSubscriber: Subscription;
  private cityValidSubscriber: Subscription;
  private cityValueSubscriber: Subscription;
  private streetValidSubscriber: Subscription;
  private streetValueSubscriber: Subscription;
  private houseNumberValidSubscriber: Subscription;
  private houseNumberValueSubscriber: Subscription;

  private webshopOrderDataViewModel: WebshopOrderDataViewModel;
  private deliveryAddressViewModel: FurtherAddressViewModel;
  private newDeliveryAddressViewModel: FurtherAddressViewModel;
  public userAddressList: FurtherAddressViewModel[] = [];

  private usePolyMap: Boolean = false;
  private webshopLocationIDs: number[];
  public userIsLoggedIn: boolean = false;
  public selectedUserAddressId: string = "";
  public usePostalCodeSuggestion: boolean = false;
  public userAddress: IUserAddress;
  // suggestion of cities based on the zip code
  public cityList: string[] = [];
  public displayCityList: boolean = false;
  public orderDataInputMaxLength = OrderDataInputMaxLength;
  public deliveryAddressQueryMaxLength = DeliveryAddressQueryMaxLength;

  public field = FieldName;
  private errorMessages: { [key: string]: string } = {};

  public ZipCodeFormControl = new FormControl('', ValidatorsConfig.forZipCode());
  public CityFormControl = new FormControl('', ValidatorsConfig.forCity());
  public StreetFormControl = new FormControl('', ValidatorsConfig.forStreet());
  public HouseNumberFormControl = new FormControl('', ValidatorsConfig.forHouseNumber());

  private zipCodeChanged: boolean = false;
  private cityChanged: boolean = false;
  private streetChanged: boolean = false;
  private houseNumberChanged: boolean = false;

  constructor(private router: Router
    , private routerHelperService: RouterHelperService
    , private changeDetectorRef: ChangeDetectorRef
    , private webShopService: WebShopService
    , private coreComService: CoreCOMService
    , private coreLogService: CoreLogService
    , private userHelperService: UserHelperService
    , private overlaySpinnerService: OverlaySpinnerService
    , private bottomSheetHelperService: BottomSheetHelperService
    , private coreLanguageService: CoreLanguageService
    , private iosHelperService: IOSHelperService
    , private geocodingService: GeocodingService
    , private locationService: LocationService
    , private activatedRoute: ActivatedRoute
    , private addressVerificationService: AddressVerificationService
    , private orderAddressQueryService: OrderAddressQueryService
    , private deviceLocationService: DeviceLocationService
  ) {
  }

  ngOnInit(): void {
    const me = this;
    me.userIsLoggedIn = me.userHelperService.IsRegistered;
    me.webshopLocationIDs = me.activatedRoute.snapshot.data["menuSettingData"].menuSettingLocationIds;
    me.webShopService.getWebshopSettingsDataModel().then(settings => {
      me.usePolyMap = settings.use_poly_map;
    });

    me.webshopOrderDataSubscription = me.webShopService.webshopOrderDataViewModelChangedAfterUserLoginStatusChangedObserver.subscribe((_) => {
      me.initializeCustomerData();
      me.PushChanges();
    });

    me.initializeCustomerData();
    me.subscribeToAllFieldChanges();
    me.PushChanges();
  }

  private PushChanges(): void {
    try {
      this.changeDetectorRef.detectChanges();
    } catch (error) {
      this.coreLogService.error("OrderAddressQueryComponent.PushChanges", "changeDetectorRef.detectChanges (catch)", error);
    }
  }

  ngOnDestroy(): void {
    const me = this;
    if (me.webshopOrderDataSubscription) {
      me.webshopOrderDataSubscription.unsubscribe();
    }
    const addresSubscriber = [
      me.zipCodeValueSubscriber,
      me.zipCodeValidSubscriber,
      me.cityValueSubscriber,
      me.cityValidSubscriber,
      me.streetValueSubscriber,
      me.streetValidSubscriber,
      me.houseNumberValueSubscriber,
      me.houseNumberValidSubscriber,
    ];
    addresSubscriber.forEach(subscriber => {
      if (subscriber) {
        subscriber.unsubscribe();
      }

    })
  }

  private subscribeToAllFieldChanges(): void {
    const me = this;
    // ZipCode
    me.zipCodeValueSubscriber = me.ZipCodeFormControl.valueChanges.subscribe(() => {
      me.zipCodeChanged = true;
      me.ZipCodeFormControl.markAsTouched();
      me.updateErrorMessage(me.ZipCodeFormControl, FieldName.ZipCode);
    });
    me.zipCodeValidSubscriber = me.ZipCodeFormControl.statusChanges.subscribe(() => {
      me.updateErrorMessage(me.ZipCodeFormControl, FieldName.ZipCode);
    });

    // City
    me.cityValueSubscriber = me.CityFormControl.valueChanges.subscribe(() => {
      me.cityChanged = true;
      me.CityFormControl.markAsTouched();
      me.updateErrorMessage(me.CityFormControl, FieldName.City);
    });
    me.cityValidSubscriber = me.CityFormControl.statusChanges.subscribe(() => {
      me.updateErrorMessage(me.CityFormControl, FieldName.City);
    });

    // Street
    me.streetValueSubscriber = me.StreetFormControl.valueChanges.subscribe(() => {
      me.streetChanged = true;
      me.StreetFormControl.markAsTouched();
      me.updateErrorMessage(me.StreetFormControl, FieldName.Street);
    });
    me.streetValidSubscriber = me.StreetFormControl.statusChanges.subscribe(() => {
      me.updateErrorMessage(me.StreetFormControl, FieldName.Street);
    });

    // HouseNumber
    me.houseNumberValueSubscriber = me.HouseNumberFormControl.valueChanges.subscribe(() => {
      me.houseNumberChanged = true;
      me.HouseNumberFormControl.markAsTouched();
      me.updateErrorMessage(me.HouseNumberFormControl, FieldName.HouseNumber);
    });
    me.houseNumberValidSubscriber = me.HouseNumberFormControl.statusChanges.subscribe(() => {
      me.updateErrorMessage(me.HouseNumberFormControl, FieldName.HouseNumber);
    });
  }

  public setWebviewAfterBlur(): void {
    this.iosHelperService.setWebviewAfterBlur();
  }

  /** close drop down list  
   *Includes the suggestion of cities based on the zip code*/
  public handleDisplayList(event: any) {
    const target = event.target as HTMLElement;
    if (!target.closest('.city-content')) {
      this.displayCityList = false;
    }
  }

  /**
   *  Gets a placeholder for given input field name and returns its translation with an asterisk because every input field is required.
   */
  public getInputPlaceholder(inputFieldName: FieldName): string {
    return this.coreLanguageService.value(`phOrderDataInputs_${inputFieldName}`) + " *";
  }

  /** 
   * When everything is valid, the user will be navigaterd to the menuLocation component.
   * Otherwise different dialogues will be shown to the user.
   */
  public async onConfirmAddressData(): Promise<void> {
    const me = this;
    const address = me._setAddressOnConfirm();

    const settings = await me.webShopService.getWebshopSettingsDataModel();

    if (!settings.google_api_available) {
      me.continueAfterAddressConfirmed(address);
      return;
    }

    try {
      const response = await me.addressVerificationService.verify({
        street: address.street,
        streetNumber: address.houseNumber,
        postalCode: address.zipCode,
        city: address.city,
      });

      me.handleVerifyResult(response, address);
    } catch (error) {
      if (me.webShopService.useMandatoryAddressVerification()) {
        me.showVerifyUnavailableError();
      }
      else {
        me.continueAfterAddressConfirmed(address);
      }
    }
  }

  private continueAfterAddressConfirmed(address: IUserAddress): void {
    const me = this;

    if (me.usePolyMap) {
      me.handlePolygonMapBehaviour(address.zipCode, address.street, address.houseNumber, address.city, address.streetAndHouseNumber);
    } else {
      me.handleDefaultBehaviour(address.zipCode, address.city, address.streetAndHouseNumber);
    }

    me.setAddressValueStorage(address.zipCode, address.city, address.street, address.houseNumber);
  }

  private handleVerifyResult(res: AddressVerifyResponse, entered: IUserAddress): void {
    const me = this;

    if (!res || res.IsValid !== true) {
      me.showAddressInvalidError();
      return;
    }

    if (res.IsAdjusted === true && res.SuggestedAddress) {
      if (me.webShopService.useMandatoryAddressVerification()) {
        me.openAdjustedDialogMandatory(entered, res.SuggestedAddress).afterDismissed().subscribe((result: AddressModalResult) => {
          if (result === AddressModalResult.FirstButton) {
            const finalAddress = me.mapSuggested(res.SuggestedAddress);
            me.continueAfterAddressConfirmed(finalAddress);
          }
        });
      } else {
        me.openAdjustedDialogOptional(entered, res.SuggestedAddress).afterDismissed().subscribe((result: AddressModalResult) => {
          if (result === AddressModalResult.FirstButton) {
            me.continueAfterAddressConfirmed(me.mapSuggested(res.SuggestedAddress));
          } else if (result === AddressModalResult.ThirdButton) {
            me.continueAfterAddressConfirmed(entered);
          }
        });
      }

      return;
    }

    me.continueAfterAddressConfirmed(entered);
  }

  private openAdjustedDialogMandatory(entered: IUserAddress, suggested: SuggestedAddress): MatBottomSheetRef<any, AddressModalResult> {
    const me = this;

    return me.bottomSheetHelperService.open(AddressVerificationDialogComponent, {
      data: {
        title: "phOrderAddressQuery_VerifyAdjusted_Title",
        compare: me.orderAddressQueryService.buildCompareVm(entered, me.mapSuggested(suggested)),
        firstBtnLabel: "phOrderAddressQuery_UseSuggestion_BtnLabel",
        secondBtnLabel: "phOrderAddressQuery_Cancel_BtnLabel"
      },
      panelClass: "mat-bottom-sheet-container--full-height"
    });
  }

  private openAdjustedDialogOptional(entered: IUserAddress, suggested: SuggestedAddress): MatBottomSheetRef<any, AddressModalResult> {
    const me = this;

    return me.bottomSheetHelperService.open(AddressVerificationDialogComponent, {
      data: {
        title: "phOrderAddressQuery_VerifyAdjusted_Title",
        compare: me.orderAddressQueryService.buildCompareVm(entered, me.mapSuggested(suggested)),
        firstBtnLabel: "phOrderAddressQuery_UseSuggestion_BtnLabel",
        secondBtnLabel: "phOrderAddressQuery_Cancel_BtnLabel",
        thirdBtnLabel: "phOrderAddressQuery_KeepMyInput_BtnLabel",
      },
      panelClass: "mat-bottom-sheet-container--full-height"
    });
  }

  private showVerifyUnavailableError(): void {
    this.bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        content: "phUserProfileAddress_VerifyUnavailable_Content",
        btnLabel: "phUserProfileAddress_VerifyUnavailable_BtnLabel",
      },
      panelClass: "mat-bottom-sheet-container-medium",
    });
  }

  private showAddressInvalidError(): void {
    this.bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        content: "phUserProfileAddress_VerifyInvalid_Content",
        btnLabel: "phUserProfileAddress_VerifyUnavailable_BtnLabel",
      },
      panelClass: "mat-bottom-sheet-container-medium",
    });
  }

  private mapSuggested(s: SuggestedAddress): IUserAddress {
    const street = s && s.Street ? s.Street.trim() : "";
    const houseNumber = s && s.HouseNumber ? s.HouseNumber.trim() : "";
    const zipCode = s && s.ZipCode ? s.ZipCode.trim() : "";
    const city = s && s.City ? s.City.trim() : "";

    return {
      street: street,
      houseNumber: houseNumber,
      zipCode: zipCode,
      city: city,
      streetAndHouseNumber: (street + " " + houseNumber).trim()
    } as IUserAddress;
  }

  private getValueFromFormInput(formControl: FormControl): string {
    return formControl ? this.removeEmptySpace(formControl.value) : undefined;
  }

  private _setAddressOnConfirm() {
    const me = this;
    const hasSelectedAddressId = me.hasValue(me.selectedUserAddressId);
    if (!hasSelectedAddressId) {
      const zipCode = me.getValueFromFormInput(me.ZipCodeFormControl);
      const city = me.getValueFromFormInput(me.CityFormControl);
      const street = me.getValueFromFormInput(me.StreetFormControl);
      const houseNumber = me.getValueFromFormInput(me.HouseNumberFormControl);
      const address = (`${street} ${houseNumber}`);
      me.userAddress = me._setSelectedAddress(zipCode, city, street, houseNumber, address);
    }//else address is selected from the list
    return me.userAddress;
  }

  /** Set input value 
    * Requirement : user is logged in and data are available */
  private _setInputStreetAndHouseNumber(userAddress: string) {
    const me = this;
    let street: string = "";
    let houseNumber: string = "";
    if (userAddress && me.hasValue(userAddress)) {
      // Attempt regex match first
      const addressPattern = /^(.*?)(\d+[\w\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df-]*)$/;
      const isValidPattern = userAddress.match(addressPattern);

      if (isValidPattern) {
        street = isValidPattern[1].trim();
        houseNumber = isValidPattern[2].trim();
      } else {
        // Fallback: Split based on the last space if regex fails
        let lastSpaceIndex = userAddress.lastIndexOf(" ");
        if (lastSpaceIndex !== -1) {
          street = userAddress.substring(0, lastSpaceIndex).trim();
          houseNumber = userAddress.substring(lastSpaceIndex + 1).trim();
        } else {
          // No split possible, assume whole input is street
          street = userAddress.trim();
        }
      }
    }

    return { street, houseNumber };
  }

  private removeEmptySpace(str: string): string {
    return str.replace(/^\s+|\s+$/g, '').replace(/\s{2,}/g, ' ');
  }

  private handlePolygonMapBehaviour(zipCode: string, street: string, houseNumber: string, city: string, address: string): void {
    const me = this;
    me.overlaySpinnerService.ShowLayoutSpinner();

    const onSuccess = (geocodeResponse: GeocodeResponse) => {
      me.overlaySpinnerService.HideLayoutSpinner();

      if (geocodeResponse && !geocodeResponse.Approximated) {
        me.setDeliveryAddress(zipCode, city, address, geocodeResponse.Coordinates);
        // todo remove route coordinates and use webshopService
        me.routerHelperService.setRouteTargetDataByKey("coordinates", geocodeResponse.Coordinates);
        me.router.navigate(["/menulocation"]);
      } else {
        me.PushChanges();
        me.openWarningNoExactLocation(zipCode, city, address);
      }
    };

    const onError = (_) => {
      me.overlaySpinnerService.HideLayoutSpinner();
      me.openWarningBottomSheet(zipCode, city, address)
    };

    me.geocodingService
      .geocode(me.createAddress(zipCode, street, houseNumber, city, address))
      .then(onSuccess)
      .catch(onError);
  }

  private createAddress(zipCode: string, street: string, houseNumber: string, city: string, address: string): Address {
    const result = new Address();
    result.street = street;
    result.streetNumber = houseNumber;
    result.postalCode = zipCode;
    result.city = city;
    return result;
  }

  private handleDefaultBehaviour(zipCode: string, city: string, address: string): void {
    const me = this;
    me.setDeliveryAddress(zipCode, city, address, null);
    me.router.navigate(["/menulocation"]);
  }

  /** validate address data */
  public addressDataValid(): boolean {
    const me = this;
    let active: boolean = false;
    const formControlList = [me.ZipCodeFormControl, me.CityFormControl, me.StreetFormControl, me.HouseNumberFormControl];
    const isFormValid = formControlList.every(control => me.hasValue(control.value.trim()) && control.valid);
    if (me.userIsLoggedIn) {
      active = me.hasValue(me.selectedUserAddressId) || isFormValid;
    } else {
      active = isFormValid;
    }

    return active;
  }

  /** Set form control value */
  private setFormControlValue(formControl: FormControl, value: string): void {
    formControl.setValue(value ? value : '');
  }

  /** Content is not empty */
  private hasValue(value: string): boolean {
    return !Utils.IsNullOrEmpty(value);
  }

  /** Get error label for field */
  public getActiveErrorLabel(fieldName: FieldName): string {
    return this.errorMessages[fieldName] || '';
  }

  /** Check if control has error and error label exists */
  public hasControlErrorAndErrorLabel(control: FormControl, fieldName: FieldName): boolean {
    return control.touched && control.invalid && !!control.errors && !!this.getActiveErrorLabel(fieldName);
  }

  /** Update error message when control changes */
  private updateErrorMessage(control: FormControl, fieldName: FieldName): void {
    const me = this;
    const errorMessages = DELIVERY_ADDRESS_FIELD_ERROR_MESSAGES[fieldName];
    const messageKey = ValidatorsConfig.getErrorMessageKey(control, errorMessages);
    let messageValue = messageKey ? me.coreLanguageService.value(messageKey) : '';
    if (control.errors && control.errors.minlength) {
      const requiredLength = control.errors.minlength.requiredLength;
      messageValue = messageValue.replace('{length}', requiredLength.toString());
    }
    if (me.errorMessages[fieldName] !== messageValue) {
      me.errorMessages[fieldName] = messageValue;
      me.PushChanges();
    }
  }

  /**
 * Updates the form controls with the logged-in user's address data.
 * Fetches the user's address data from the webshop service and sets the form controls accordingly.
 * If the user has multiple addresses, it sets the first address found.
 */
  private updateFormControlAddressValue(addressData: FurtherAddressViewModel) {
    const me = this;
    const hasAddress = me.userAddressList.length > 0;
    if (hasAddress) {
      me.setFormControlValue(me.ZipCodeFormControl, addressData.zip_code);
      me.setFormControlValue(me.CityFormControl, addressData.city);
      const street = me._setInputStreetAndHouseNumber(addressData.address.trim()).street;
      const houseNumber = me._setInputStreetAndHouseNumber(addressData.address.trim()).houseNumber;
      me.setFormControlValue(me.StreetFormControl, street);
      me.setFormControlValue(me.HouseNumberFormControl, houseNumber);
    }
  }

  private async setUserAddresList() {
    const me = this;
    if (me.userIsLoggedIn) {
      me.webshopOrderDataViewModel = await me.webShopService.GetWebshopOrderDataViewModel();
      const hasAddress = me.webshopOrderDataViewModel && me.webshopOrderDataViewModel.furtherAddresses.length > 0;
      if (hasAddress) {
        me.userAddressList = me.webShopService.webshopOrderDataViewModel.furtherAddresses;
      }
      me.PushChanges();
    }

  }

  private setLoggedinUserAddressOnload() {
    const me = this;
    if (me.userIsLoggedIn) {
      const addressData = me.userAddressList[0];
      me.updateFormControlAddressValue(addressData);
      me.PushChanges();
    }
  }

  private async setAddressFromStorage() {
    const me = this;
    const keys = [LocalKeys.deliveryPostCode, LocalKeys.deliveryCity, LocalKeys.deliveryStreet, LocalKeys.houseNumber];
    const [deliveryPostCode, deliveryCity, deliveryStreet, houseNumber] = await Promise.all(
      keys.map(key => me.coreComService.environment.valueStorage.get(StorageHive.Local, key))
    );
    const hasAddressInLocalStorage = [deliveryPostCode, deliveryCity, deliveryStreet, houseNumber].every(me.hasValue);

    if (hasAddressInLocalStorage) {
      me.setFormControlValue(me.ZipCodeFormControl, deliveryPostCode);
      me.setFormControlValue(me.CityFormControl, deliveryCity);
      me.setFormControlValue(me.StreetFormControl, deliveryStreet);
      me.setFormControlValue(me.HouseNumberFormControl, houseNumber);
    }
    me.PushChanges();
  }

  /** Initialise the billing and delivery address */
  private async initializeCustomerData() {
    const me = this;
    me.deliveryAddressViewModel = me.webShopService.getDelivaryAddress();
    await me.setUserAddresList();
    me.getPostalCodeForCurrentLocation().then(postalCodeSuggestion => {
      if (postalCodeSuggestion) {
        me.usePostalCodeSuggestion = true
        // load suggestion of postal code based on the current location
        me.setFormControlValue(me.ZipCodeFormControl, postalCodeSuggestion);
      } else {
        if (me.userIsLoggedIn) {
          // load the first user address from the list and set input value
          me.setLoggedinUserAddressOnload();
        } else {
          // load the address from local storage and set input value
          me.setAddressFromStorage();
        }
      }
      me.PushChanges();
    }).catch(() => {
      // Do nothing
    });
  }

  public displayUserAddressListItem(address: FurtherAddressViewModel): string {
    const me = this;
    const street = me.hasValue(address.address) ? address.address.trim() : "";
    const zipCode = me.hasValue(address.zip_code) ? address.zip_code.trim() : "";
    const city = me.hasValue(address.city) ? address.city.trim() : "";
    return (`${street}, ${zipCode} ${city}`);
  }

  public hasMultipleAddresses(): boolean {
    const me = this;
    return me.userAddressList && me.userAddressList.length > 1;
  }

  private inputControlsAreEmpty(): boolean {
    const me = this;
    return [me.ZipCodeFormControl, me.CityFormControl, me.StreetFormControl, me.HouseNumberFormControl]
      .every(control => control && !me.hasValue(control.value.trim()));
  }

  public isCitySelectedById(cityId: string, radioButton: MatRadioButton): boolean {
    const me = this;
    let checked: boolean = false;
    if (me.inputControlsAreEmpty()) {
      checked = me.selectedUserAddressId === cityId;
    } else {
      me.selectedUserAddressId = "";
      checked = false;
    }
    return radioButton.checked = checked;
  }

  public onAddressSelectionChange(addressId: string): void {
    const me = this;
    // reset input values
    const formControlList = [me.ZipCodeFormControl, me.CityFormControl, me.StreetFormControl, me.HouseNumberFormControl];
    formControlList.forEach(control => {
      if (control) {
        control.reset("");
        control.markAsUntouched();
        control.markAsPristine();
      }
    });
    me.selectedUserAddressId = addressId;
    const address = me.userAddressList.find(address => address.id === addressId);
    const houseNumber = me._setInputStreetAndHouseNumber(address.address.trim()).houseNumber;
    const street = me._setInputStreetAndHouseNumber(address.address.trim()).street;
    me.userAddress = me._setSelectedAddress(address.zip_code, address.city, street, houseNumber, address.address);
    me.PushChanges();
  }

  private _setSelectedAddress(zipCode: string, city: string, street: string, houseNumber: string, streetAndHouseNumber: string) {
    const userAddress: IUserAddress = { zipCode: zipCode, city: city, street: street, houseNumber: houseNumber, streetAndHouseNumber: streetAndHouseNumber };
    return userAddress;
  }

  /** Gets unique city names by zip code from the location list.*/
  private deliveryCityListByZipCode(zipCode: string, locationList: LocationWebshopViewModel[]): string[] {
    const deliveryCityList: string[] = [];
    locationList.forEach(location => {
      if (location.delivery_areas) {
        location.delivery_areas.forEach(deliveryArea => {
          if (deliveryArea.zip === zipCode) {
            const city = deliveryArea.city.trim();
            if (!deliveryCityList.includes(city)) {
              deliveryCityList.push(city);
            }
          }
        });
      }
    });
    return deliveryCityList;
  }

  /**
   * Handles blur event for zip code input.
   * Fetches and updates city list if user is not logged in.
   */
  public handleZipCodeBlur() {
    const me = this;
    if (!me.userIsLoggedIn) {
      const zipCode = me.ZipCodeFormControl.value.trim();
      if (me.hasValue(zipCode)) {
        // Reset the city list before fetching new cities
        me.cityList = [];
        me.locationService.GetWebshopLocationViewModel(WebShopMode.Delivery, me.webshopLocationIDs, null, zipCode).then((location) => {
          const cities = me.deliveryCityListByZipCode(zipCode, location);
          cities.forEach(city => {
            if (city && !me.cityList.includes(city)) {
              me.cityList.push(city);
            }
          });
        });
        me.PushChanges();
      }
    }
  }

  /* suggestion of cities based on the zip code*/
  public selectCity(city: string) {
    const me = this;
    me.setFormControlValue(me.CityFormControl, city);
  }

  private async getPostalCodeForCurrentLocation(): Promise<string> {
    const me = this;
    me.overlaySpinnerService.ShowLayoutSpinner();

    try {
      const coordinates = await me.deviceLocationService.getCurrentPosition();
      if (coordinates) {
        return await me.deviceLocationService.getPostalCodeForCoordinates(coordinates);
      }
    } catch (error) {
      return undefined;
    } finally {
      me.overlaySpinnerService.HideLayoutSpinner();
    }
  }

  private setDeliveryAddress(zipCode: string, city: string, address: string, geoCoordinates: Coordinates) {
    const me = this;
    //! TODO warum wird hier die Adresse unterschiedlich gesetzt?
    //! NewFurtherAddress, DestinationData, DeliveryAddress und CurrentlyUsedAddress > was sind die unterschiede?
    if (me.userIsLoggedIn) {
      if (me.userChangedAddress()) {
        // Data was inserted when the user is logged in and the address was manipulated, therefore it is another address than the home address.
        me.setNewFurtherAddress(zipCode, city, address);
        me.webShopService.setDeliveryAddress(me.deliveryAddressViewModel);
      }
    }
    //! todo geo location need to be saved until basket
    //! TODO setDstionation ist hier falsch, diese werden gesetzt wenn der standort ausgew�lt wurde
    me._setDestinationData(zipCode, city, address);
    me.webShopService.setCurrentlyUsedAddress(zipCode, city, address, geoCoordinates);
  }

  /** Set the address if the user is logged in and has changed the address.*/
  private userChangedAddress(): boolean {
    const me = this;
    return me.zipCodeChanged || me.cityChanged || me.streetChanged || me.houseNumberChanged;
  }

  /** new delivery address
   * Requirement : user is logged in & has further address & user changed data */
  private setNewFurtherAddress(zipCode: string, city: string, address: string) {
    const me = this;
    me.newDeliveryAddressViewModel = new FurtherAddressViewModel();
    me.newDeliveryAddressViewModel.zip_code = zipCode;
    me.newDeliveryAddressViewModel.city = city;
    me.newDeliveryAddressViewModel.address = address;
    return me.deliveryAddressViewModel = me.newDeliveryAddressViewModel;
  }

  private _setDestinationData(zipCode: string, city: string, address: string) {
    const me = this;
    me.webShopService.DestinationZipCode = zipCode;
    me.webShopService.DestinationCity = city;
    me.webShopService.DestinationAddress = address;
  }

  /** Save delivery data to local storage.*/
  private setAddressValueStorage(postCode: string, city: string, street: string, streetNumber: string) {
    const me = this;
    me.coreComService.environment.valueStorage.set(StorageHive.Local, LocalKeys.deliveryPostCode, postCode);
    me.coreComService.environment.valueStorage.set(StorageHive.Local, LocalKeys.deliveryCity, city);
    me.coreComService.environment.valueStorage.set(StorageHive.Local, LocalKeys.deliveryStreet, street);
    me.coreComService.environment.valueStorage.set(StorageHive.Local, LocalKeys.houseNumber, streetNumber);
  }

  // region Dialogs 
  private openWarningNoExactLocation(zipCode: string, city: string, address: string) {
    const me = this;
    const warningModal = me.bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        content: "ph_menuLocation_Address_Required_Warning_Info",
        btnLabel: "phGlobal_Continue",
      },
      panelClass: "mat-bottom-sheet-container-medium",
    });
    warningModal.afterDismissed().subscribe(() => {
      me.handleDefaultBehaviour(zipCode, city, address);
    })
  }

  private openWarningBottomSheet(zipCode: string, city: string, address: string) {
    const me = this;
    const warningButtomSheet = me.bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "ph_orderAddressQuery_ApproximatedAddress_Title"
        , content: "ph_orderAddressQuery_ApproximatedAddress_Content"
        , btnLabel: "ph_orderAddressQuery_ApproximatedAddress_BtnLabel"
        , option: "ph_orderAddressQuery_ApproximatedAddress_Option"
      },
      panelClass: "mat-bottom-sheet-container--full-height"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      if (result) {
        me.handleDefaultBehaviour(zipCode, city, address);
      }
    });
  }

  // endregion Dialogs

}